import React from "react";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { ConfirmationActiveDevise } from "../ConfirmationActiveDevise";
import HistoryModal from "../HistoryModal";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";

export default function ModalsContainer({
    isActionsClicked,
    setIsActionsClicked,
    validationAction,
    actions,
    setIsEdited,
    isModalConfirmationOpened,
    setIsModalConfirmationOpened,
    setDataIsUpdated,
    isHistoryModalOpened,
    setIsHistoryModalOpened,
    selectedRows,
    isInInitializationModalOpened,
    setIsInInitializationModalOpened,
    setIsAddNewDeviseButtonClicked,
    isAddNewDeviseButtonClicked,
    activationDeactivationMessageModalOpened,
    oneShop,
}: any) {
    return (
        <React.Fragment>
            {isActionsClicked && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            )}

            <ConfirmationActiveDevise
                setIsModalOpened={setIsModalConfirmationOpened}
                isModalOpened={isModalConfirmationOpened}
                setDataIsUpdated={setDataIsUpdated}
            />

            {isHistoryModalOpened && (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                />
            )}

            {isInInitializationModalOpened && (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewDeviseButtonClicked}
                    isClicked={isAddNewDeviseButtonClicked}
                    setIsEdited={setIsEdited}
                />
            )}

            {activationDeactivationMessageModalOpened && oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
        </React.Fragment>
    );
}
